export default "__VITE_ASSET__KHE5KCN3__"